export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Final2_05.00aea4ef.jpg";